/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")
        //
        .factory("customerService", [
            "$http", "$q", "$translate", "$oidc",
            function (http, q, translate, oidc) {

                var customerService = {};

                customerService.lookup = function (retailerId, searchText) {
                    return http
                        .get("/api/customer/search", {
                            params: {
                                retailerId: retailerId,
                                searchText: searchText
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            },
                            cache: true
                        })
                        .then(function (response) {
                            return translate("CustomerNotFoundCreateNewOne")
                                .then(function (translation) {
                                    var result = response.data.slice(0, 15);
                                    result.push({
                                        Id: 0,
                                        SearchText: translation
                                    });
                                    return result;
                                }, function () {
                                    var result = response.data.slice(0, 15);
                                    result.push({
                                        Id: 0,
                                        SearchText: "... customerNotFoundCreateNewOne ..."
                                    });
                                    return result;
                                });
                        });
                };

                customerService.get = function (retailerId, customerId) {
                    return http
                        .get("/api/customer/well/" + customerId, {
                            params: {
                                retailerId: retailerId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            return response.data;
                        });
                };

                return customerService;
            }
        ]);
})();